import {
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PhotoCameraModalComponent } from '../photo-camera-modal/photo-camera-modal.component';
import * as moment from 'moment';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: FileInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: FileInputComponent,
    },
  ],
})
export class FileInputComponent {
  @Input()
  isDisabled = false;

  @Input()
  allowCamera = true;

  @Input()
  acceptedFileTypes = '*/*';

  @ViewChild('fileInput')
  fileInput!: ElementRef;


  public value?: File;
  public localValue?: File;

  constructor(
    private modalService: NgbModal,
  ) {
  }

  ngOnInit(): void {
  }

  onChange = (val: File | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val: File) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.value;
    }
  }

  setInputFile(file: File): void {
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    this.fileInput.nativeElement.files = dataTransfer.files;
    const event = new Event('change', { bubbles: true });
    this.fileInput.nativeElement.dispatchEvent(event);
  }

  photoCameraModal() {
    const modalRef = this.modalService.open(PhotoCameraModalComponent, {
      centered: true,
      size: 'md',
      backdrop: 'static',
    });
    modalRef.result.then((blob: Blob | undefined) => {
      if (blob) {
        const file = this.blobToFile(blob, `Captured Image - ${moment().format('x')}.png`);
        this.setInputFile(file);
      }
    });
  }

  blobToFile(blob: Blob, fileName: string): File {
    const file = new File([blob], fileName, {
      type: blob.type,
      lastModified: Date.now() // Optional for a more realistic File object
    });
    return file;
  }


  onValueChange(event: Event) {
    this.value = (event.target as HTMLInputElement).files![0];
    this.onChange(this.value);
this.writeValue(this.value);
    console.log(this.value);

  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
